var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "5px",
    viewBox: "0 0 10 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FCEE7D39-924E-4869-8063-FE09F88D1448") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(-1269.000000, -47.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1278.37465,47.6253476 L1274.35355,51.6464466 C1274.15829,51.8417088 1273.84171,51.8417088 1273.64645,51.6464466 L1269.62491,47.6249056 C1269.48195,47.4819498 1269.48195,47.2501727 1269.62491,47.1072169 C1269.69356,47.0385671 1269.78666,47 1269.88375,47 L1270.56041,47 C1270.69301,47 1270.82018,47.0526728 1270.91394,47.146432 L1273.85857,50.0908175 C1273.93667,50.1689348 1274.0633,50.1689296 1274.1414,50.0908215 C1274.14141,50.0908163 1274.14141,50.0908111 1274.1414,50.0907902 L1277.08479,47.1465004 C1277.17857,47.0526993 1277.30577,47 1277.4384,47 L1278.11563,47 C1278.31794,47 1278.48195,47.1640071 1278.48195,47.3663201 C1278.48195,47.4634743 1278.44335,47.5566492 1278.37465,47.6253476 Z",
    id: "dropdown-copy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.d2095d869cc4692e8a0612ed21774c1a.svg";
export { ForwardRef as ReactComponent };